<!-- 网站首页 -->
<template>
  <div @touchmove.prevent class="jietu_group">
    <div class="jietu_center hidden-xs hidden-sm hidden-md">
      <div id="content" ref="content_pc" class="jietu_content p_no_click">
        <!-- https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0941357080.jpg -->
        <img class="jietu_content_bg" :src="bigUrl + '?imageMogr2/format/jpg'" alt="" />
        <!--  -->
        <img class="jietu_content_img border_radius_round" :src="GET_USER.avatar + '?imageMogr2/format/jpg'" alt="" />
        <div class="jietu_content_user p_flex">
          <div class="jietu_content_right color_ffffff">
            <div class="jietu_content_nick font_14 font_bold">{{ GET_USER.nickName }}</div>
            <div class="jietu_content_id font_12">SnailShell ID :{{ GET_USER.salt }}</div>
          </div>
        </div>
        <!--  -->
        <div class="jietu_content_number color_ffffff font_15 font_bold">NO.{{ productNum }}</div>
      </div>
      <div class="btn_group p_flex p_space_between font_18 p_text_center">
        <div @click="download" class="btn_down color_ffffff bg_DC000C border_radius6 p_hand">{{$t('content.download')}}</div>
        <div @click="$emit('callback')" class="btn_cancel bg_ffffff color_DC000C border_radius6 p_hand">{{$t('content.cancel')}}</div>
      </div>
    </div>
    <!-- h5 -->
    <div class="jietu_center_h5 hidden-lg">
      <div id="_content" ref="content_h5" class="jietu_content_h5 p_no_click">
        <!-- https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0941357080.jpg -->
        <img class="jietu_content_bg_h5" :src="bigUrl + '?imageMogr2/format/jpg'" alt="" />
        <!--  -->
        <img class="jietu_content_img_h5 border_radius_round" :src="GET_USER.avatar + '?imageMogr2/format/jpg'"
          alt="" />
        <div class="jietu_content_user_h5 p_flex">
          <div class="jietu_content_right_h5 color_ffffff">
            <div class="jietu_content_nick_h5 font_bold">{{ GET_USER.nickName }}</div>
            <div class="jietu_content_id_h5">SnailShell ID :{{ GET_USER.salt }}</div>
          </div>
        </div>
        <!--  -->
        <div class="jietu_content_number_h5 color_ffffff font_bold">NO.{{ productNum }}</div>
      </div>
    </div>
    <div class="btn_group_h5 hidden-lg p_flex p_space_between p_text_center">
      <div @click="download" class="btn_down_h5 color_ffffff bg_DC000C border_radius6 p_hand">{{$t('content.download')}}</div>
      <div @click="$emit('callback')" class="btn_cancel_h5 bg_ffffff color_DC000C border_radius6 p_hand">{{$t('content.cancel')}}</div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  import html2canvas from 'html2canvas';
  import {
    public_uploadimg
  } from '@/network/index.js';
  export default {
    data() {
      return {};
    },
    props: {
      productNum:{
        type:String
      },
      bigUrl:{
        type:String,
        default: {}
      }
    },
    components: {},
    computed: {
      ...mapGetters('login', ['GET_USER'])
    },
    methods: {
      replace_str(content) {
        return content.replace('https', 'https');
      },
      // getJpeg(dom) {
      //   return new Promise(resolve => {
      //     html2canvas(dom).then(canvas => {
      //       const jpeg = canvas.toDataURL('image/jpeg', 1.0);
      //       // resolve(new Blob([jpeg]));
      //       resolve(this.base64ToFile(jpeg));
      //     });
      //   });
      // },
      // base64转化为file文件
      // base64ToFile(urlData) {
      //   const arr = urlData.split(',');
      //   const mime = arr[0].match(/:(.*?);/)[1];
      //   const bytes = atob(arr[1]);
      //   let n = bytes.length;
      //   const ia = new Uint8Array(n);
      //   while (n--) {
      //     ia[n] = bytes.charCodeAt(n);
      //   }
      //   return new File([ia], 'jpeg', {
      //     type: mime
      //   });
      // },
      //====================
      // 第一种调用后台接口form-data传file文件
      // async download() {
      //   const resultContentJpeg = await this.getJpeg(this.$refs.content);
      //   const formData = new FormData();
      //   formData.append("uploadImg",resultContentJpeg)

      //   public_uploadimg(formData).then((res)=>{
      //     if(res.code==='0'){
      //       console.log(res)
      //       this.$message({
      //         message: 'success!',
      //         type: 'success'
      //       });
      //     }
      //   })
      // },
      // 第二种方式直接下载图片
      download() {
        let pingmu = document.documentElement.clientWidth
        let ref;
        if (pingmu > 1183) {
          ref = this.$refs.content_pc; // 截图区域
        } else {
          ref = this.$refs.content_h5; // 截图区域
        }
        html2canvas(ref, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          scale: 2
        }).then(canvas => {
          const dataURL = canvas.toDataURL('image/jpg');
          const creatDom = document.createElement('a');
          document.body.appendChild(creatDom);
          creatDom.href = dataURL;
          creatDom.download = 'cards';
          creatDom.click();
        });
      }
    }
  };
</script>

<style scoped="scoped">
  .jietu_group {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .jietu_center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 375px;
    margin: 0 auto;
  }

  .jietu_content {
    position: relative;
    width: 375px;
    height: 650px;
  }

  .jietu_content_bg {
    width: 375px;
    height: 650px;
  }

  .btn_group {
    padding: 30px 20px 0 20px;
  }

  .jietu_content_user {
    position: absolute;
    left: 65px;
    bottom: 70px;
  }

  .jietu_content_img {
    position: absolute;
    bottom: 70px;
    left: 9px;
    width: 44px;
    height: 44px;
    margin-right: 12px;
  }

  .jietu_content_right {}

  .jietu_content_number {
    position: absolute;
    left: 9px;
    bottom: 39px;
  }

  .btn_down {
    width: 200px;
    height: 50px;
    line-height: 50px;
  }

  .btn_cancel {
    width: 115px;
    height: 50px;
    line-height: 50px;
  }

  /* h5 */
  .jietu_center_h5 {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 7.5rem;
    margin: 0 auto;
  }

  .jietu_content_h5 {
    position: relative;
    width: 7.5rem;
    height: 13rem;
  }

  .jietu_content_bg_h5 {
    width: 7.5rem;
    height: 13rem;
  }

  .jietu_content_nick_h5 {
    font-size: 0.28rem;
  }

  .jietu_content_id_h5 {
    font-size: 0.24rem;
  }

  .btn_group_h5 {
    position: fixed;
    bottom: 0.4rem;
    width: 7.5rem;
    font-size: 0.36rem;
    padding: 0.6rem 0.4rem 0 0.4rem;
  }

  .jietu_content_user_h5 {
    position: absolute;
    left: 1.3rem;
    bottom: 1.4rem;
  }

  .jietu_content_img_h5 {
    position: absolute;
    bottom: 1.4rem;
    left: 0.18rem;
    width: 0.88rem;
    height: 0.88rem;
    margin-right: 0.24rem;
  }

  .jietu_content_right_h5 {}

  .jietu_content_number_h5 {
    position: absolute;
    left: 0.18rem;
    bottom: 0.78rem;
    font-size: 0.3rem;
  }

  .btn_down_h5 {
    width: 4rem;
    height: 1rem;
    line-height: 1rem;
  }

  .btn_cancel_h5 {
    width: 2.3rem;
    height: 1rem;
    line-height: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-downloadCard/public-downloadCard.vue